/**
 * Common - Events module
 */

// Imports
import 'core-js/es';
import {
  isEmpty,
} from '../common/Utils';

/**
 * Name of the event fired when
 * the header is ready.
 * @type {String}
 */
const headerReadyEventName = 'headerReady';

/**
 * Name of the event fired when
 * the site is ready.
 * @type {String}
 */
const siteReadyEventName = 'siteReady';

/**
 * Name of the event fired when
 * the dataLayer is ready.
 * @type {String}
 */
const dataLayerReadyEventName = 'dataLayerReady';

/**
 * Name of the event fired when
 * we want to open a popin.
 * @type {String}
 */
const openPopinEventName = 'openPopin';

/**
 * Name of the event fired when
 * we want to open a popin.
 * @type {String}
 */
const closePopinEventName = 'closePopin';

/**
 * Name of the event fired when
 * the cart has just been updated.
 * @type {String}
 */
const cartUpdateEventName = 'cartUpdated';

/**
 * Name of the event fired when
 * an item has just been added to the cart.
 * @type {String}
 */
const cartItemAddedEventName = 'cartItemAdded';

/**
 * Name of the event fired when
 * an item has just been removed from the cart.
 * @type {String}
 */
const cartItemRemovedEventName = 'cartItemRemoved';

/**
 * Name of the event fired when
 * an item qty in cart has just reached the maximum qty authorized.
 * @type {String}
 */
const cartItemQtyReachLimitEventName = 'cartItemQtyReachLimit';

/**
 * Name of the event fired when
 * an item qty in cart has just move below the maximum qty limitation.
 * @type {String}
 */
const cartItemQtyBelowLimitEventName = 'cartItemQtyBelowLimit';

/**
 * Name of the event fired when
 * an item has just been added to the wishlist.
 * @type {String}
 */

const wishlistItemAddedEventName = 'addToWishlist';

/**
 * Name of the event fired when
 * an item has just been removed from the wishlist.
 * @type {String}
 */
const wishlistItemRemovedEventName = 'wishlistItemRemoved';

/**
 * Name of the event fired when
 * a product thumbnail from a product list
 * has just been clicked.
 * @type {String}
 */
const productThumbnailClickedEventName = 'productThumbnailClicked';

/**
 * Name of the event fired when
 * a product thumbnail from a product list
 * has just been clicked.
 * @type {String}
 */
const algoliaProductThumbnailClickedEventName = 'algoliaProductThumbnailClicked';

/**
 * Name of the event fired when
 * more products are shown for the product list.
 * @type {String}
 */
const productListShowMoreEventName = 'productListShowMore';

/**
 * Name of the event fired when
 * products are shown for the product list in an instant search panel.
 * @type {String}
 */
const algoliaProductListShownEventName = 'algoliaProductListShown';

/**
 * Name of the event fired when
 * a sort condition has just been chosen for the product list.
 * @type {String}
 */
const productListSortByEventName = 'productListSortBy';

/**
 * Name of the event fired when
 * a sort condition has just been chosen for the product list.
 * @type {String}
 */
const algoliaProductListSortByEventName = 'algoliaProductListSortBy';

/**
 * Name of the event fired when
 * a filter option has just been selected/unselected for the product list.
 * @type {String}
 */
const productListFilterByEventName = 'productListFilterBy';

/**
 * Name of the event fired when
 * a filter option has just been selected/unselected for the product list.
 * @type {String}
 */
const algoliaProductListFilterByEventName = 'algoliaProductListFilterBy';

/**
 * Name of the event fired when
 * a new tab has just been selected from a Tablist widget.
 * @type {String}
 */
const tablistTabChangeEventName = 'tablistTabChange';

/**
 * Name of the event fired when
 * a marker or an item has just been selected
 * from the Storelocator boutique list.
 * @type {String}
 */
const storeLocMarkerChangeEventName = 'storeLocMarkerChange';

/**
 * Name of the event fired when
 * an item has just been added to the cart.
 * @type {String}
 */
const samplesAddedEventName = 'samplesAdded';


/**
 * Name of the event fired when
 * an item has just been selected from the product carousel.
 * @type {String}
 */
const productPictureChangeEventName = 'productPictureClicked';

/**
 * Name of the event fired when
 * an item has just been added to the cart.
 * @type {String}
 */
const checkoutOptionEventName = 'checkoutOption';

/**
 * Name of the event fired when
 * an item has just been added to the cart.
 * @type {String}
 */
const checkStockInStoreClickEventName = 'checkStockInStoreClick';

/**
 * Name of the event fired when

 * user scroll to a product list module
 * @type {String}
 */
const scrollToProductListEventName = 'ScrollToProductList';

/** skincare Diagnostic is completed form is validated
* @type {String}
*/
const skinDiagnosticCompletedEventName = 'skinDiagnosticCompleted';

/**
 * Name of the event fired for
 * each skincare Diagnostic steps
 * @type {String}
 */
const skinCareDiagnosticPageviewEventName = 'skinCareDiagnosticPageview';

/**
 * Name of the event fired when
 * the dataLayer is ready.
 * @type {String}
 */
const beautyProfileCompletedEventName = 'beautyProfileCompleted';

/**
 * Name of the event fired when
 * a social network in the footer is clicked
 * @type {String}
 */
const socialFollowEventName = 'socialFollow';

/**
 * Name of the event fired when
 * a social network in the footer is clicked
 * @type {String}
 */
const productSocialViralityEventName = 'productSocialShare';

/**


 * Name of the event fired for
 * each promotion view
 * @type {String}
 */
const promotionViewEventName = 'eePromoView';

/**
 * Name of the event fired for
 * each promotion click
 * @type {String}
 */
const promotionClickEventName = 'eePromoClick';

/**
* Action name for when
* the popin's back in stock notification btn has been clicked.
* @type {String}
*/
const backInStockNotificationEventName = 'backInStockNotificationSubmitted';

/**
 * Action name for when
 * read reviews link has been clicked.
 * @type {String}
*/
const readReviewsEventName = 'readReviewClicked';

/**
 * Action name for when
 * a review is submitted.
 * @type {String}
*/
const submitReviewEventName = 'reviewSubmitted';

/**
 * Action name for when
 * item is removed from cart.
 * @type {String}
*/
const removeFromCartEventName = 'removeFromCart';

/**
 * Action name for when
 * Express Delivery Eligibility is selected in checkout step3.
 * @type {String}
*/
const expressDeliverySelectionEligibilityEventName = 'expressDeliverySelectionEligibility';

/**
 * Action name for when
 * Express Delivery Ineligibility is selected in checkout step3.
 * @type {String}
*/
const expressDeliverySelectionIneligibilityEventName = 'expressDeliverySelectionIneligibility';


/**
 * Map used to store event names.
 * @type {Object}
 */
const eventNames = new Map();

/**
 * Map used to store handlers attached to events.
 * @type {Object}
 */
const eventHandlers = new Map();

/**
 * Map used to store callbacks attached to events.
 * @type {Object}
 */
const eventCallbacks = new Map();

/**
 * Triggers the event that marks the moment
 * when the cart has just been updated.
 * @param {Boolean} abSuccess     - Success/Error of the update request.
 * @param {Object}  aoRootElement - Root element of the HTML response.
 */
function triggerCartUpdateEvent(abSuccess, aoRootElement) {
  $(document).trigger(
    cartUpdateEventName,
    [
      abSuccess || false,
      aoRootElement || null,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when one or more items have just been added to the cart.
 * @param {Array}  aaProductsData         - Array of products data.
 * @param {String} aaProductsData[].sku   - SKU for the product.
 * @param {String} aaProductsData[].title - Title for the product.
 * @param {String} aaProductsData[].price - Price for the product.
 * @param {Number} [aaProductsData[].qty] - Quantity for the product.
 */
function triggerCartItemAddedEvent(aaProductsData) {
  $(document).trigger(
    cartItemAddedEventName,
    [
      aaProductsData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when one or more items have just been added to the cart.
 * @param {Array}  aaProductsData         - Array of products data.
 * @param {String} aaProductsData[].sku   - SKU for the product.
 * @param {String} aaProductsData[].title - Title for the product.
 * @param {String} aaProductsData[].price - Price for the product.
 */
function triggerCartItemRemovedEvent(aaProductsData) {
  $(document).trigger(
    cartItemRemovedEventName,
    [
      aaProductsData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when one or more items have just been added to the wishlist.
 * @param {Array}  aaProductsData         - Array of products data.
 * @param {String} aaProductsData[].sku   - SKU for the product.
 * @param {String} aaProductsData[].title - Title for the product.
 * @param {String} aaProductsData[].size  - Size for the product.
 * @param {String} aaProductsData[].price - Price for the product.
 */
function triggerWishlistItemAddedEvent(aaProductsData) {
  $(document).trigger(
    wishlistItemAddedEventName,
    [
      aaProductsData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when an item has just been removed from the wishlist.
 * @param {String} asSKU - SKU.
 */
function triggerWishlistItemRemovedEvent(asSKU) {
  $(document).trigger(
    wishlistItemRemovedEventName,
    [
      asSKU,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when user clicks on a product thumbnail from a product list.
 * @param {Object} aoProductData         - Product data object.
 * @param {String} aoProductData.id      - SKU for the product.
 * @param {String} aoProductData.name    - Name of the product.
 * @param {String} aoProductData.variant - Variant for the product.
 * @param {String} aoProductData.price   - Price for the product.
 */
function triggerProductThumbnailClickedEvent(aoProductData) {
  $(document).trigger(
    productThumbnailClickedEventName,
    [
      aoProductData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when user clicks on a product thumbnail from an instant search product list panel.
 * @param {Object} aoProductData         - Product data object.
 * @param {String} aoQuery               - search keyword.
 */
function triggerAlgoliaProductThumbnailClickedEvent(aoProductData, aoQuery) {
  $(document).trigger(
    algoliaProductThumbnailClickedEventName,
    [
      aoProductData,
      aoQuery,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when more products are shown for the product list.
 * @param {Array}  aaProductsData         - Array of products data.
 * @param {String} aaProductsData[].sku   - SKU for the product.
 * @param {String} aaProductsData[].title - Title for the product.
 * @param {String} aaProductsData[].size  - Size for the product.
 * @param {String} aaProductsData[].price - Price for the product.
 */
function triggerProductListShowMoreEvent(aaProductsData) {
  $(document).trigger(
    productListShowMoreEventName,
    [
      aaProductsData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when more products are shown for the product list.
 * @param {Array}  aoProductData         - Array of products data.
 * @param {String} aoProductData[].sku   - SKU for the product.
 * @param {String} aoProductData[].title - Title for the product.
 * @param {String} aoProductData[].size  - Size for the product.
 * @param {String} aoProductData[].price - Price for the product.
 */
function triggerAlgoliaProductListShownEvent(aoProductData, aoQuery, nextPage, isLandingSearch) {
  $(document).trigger(
    algoliaProductListShownEventName,
    [
      aoProductData,
      aoQuery,
      nextPage,
      isLandingSearch,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when a sort condition has just been chosen for the product list.
 * @param {Array}  aaProductsData         - Array of products data.
 * @param {String} aaProductsData[].sku   - SKU for the product.
 * @param {String} aaProductsData[].title - Title for the product.
 * @param {String} aaProductsData[].size  - Size for the product.
 * @param {String} aaProductsData[].price - Price for the product.
 * @param {Array}  aoContextData          - Object of context data.
 * @param {String} aoContextData.filters  - Product list filters.
 * @param {String} aoContextData.sortType - Product list sort type.
 */
function triggerProductListSortByEvent(aaProductsData, aoContextData) {
  $(document).trigger(
    productListSortByEventName,
    [
      aaProductsData,
      aoContextData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when a sort condition has just been chosen for the product list.
 * @param {Array}  aaProductsData         - Array of products data.
 * @param {String} aaProductsData[].sku   - SKU for the product.
 * @param {String} aaProductsData[].title - Title for the product.
 * @param {String} aaProductsData[].size  - Size for the product.
 * @param {String} aaProductsData[].price - Price for the product.
 * @param {Array}  aoContextData          - Object of context data.
 * @param {String} aoContextData.filters  - Product list filters.
 * @param {String} aoContextData.sortType - Product list sort type.
 */
function triggerAlgoliaProductListSortByEvent(aaProductsData, aoContextData) {
  $(document).trigger(
    algoliaProductListSortByEventName,
    [
      aaProductsData,
      aoContextData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when a filter option has just been selected/unselected for the product list.
 * @param {Array}  aaProductsData         - Array of products data.
 * @param {String} aaProductsData[].sku   - SKU for the product.
 * @param {String} aaProductsData[].title - Title for the product.
 * @param {String} aaProductsData[].size  - Size for the product.
 * @param {String} aaProductsData[].price - Price for the product.
 * @param {Array}  aoContextData          - Object of context data.
 * @param {String} aoContextData.filters  - Product list filters.
 * @param {String} aoContextData.sortType - Product list sort type.
 */
function triggerProductListFilterByEvent(aaProductsData, aoContextData) {
  $(document).trigger(
    productListFilterByEventName,
    [
      aaProductsData,
      aoContextData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when a filter option has just been selected/unselected for the product list in instant search panel.
 * @param {Array}  aaProductsData         - Array of products data.
 * @param {String} aaProductsData[].sku   - SKU for the product.
 * @param {String} aaProductsData[].title - Title for the product.
 * @param {String} aaProductsData[].size  - Size for the product.
 * @param {String} aaProductsData[].price - Price for the product.
 * @param {Array}  aoContextData          - Object of context data.
 * @param {String} aoContextData.filters  - Product list filters.
 * @param {String} aoContextData.sortType - Product list sort type.
 */
function triggerAlgoliaProductListFilterByEvent(aaProductsData, aoContextData) {
  $(document).trigger(
    algoliaProductListFilterByEventName,
    [
      aaProductsData,
      aoContextData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when a new tab has just been selected from a Tablist widget.
 * @param {Object} aoTablistContainer - Tablist container.
 */
function triggerTablistTabChangeEvent(aoTablistContainer) {
  $(document).trigger(
    tablistTabChangeEventName,
    [
      aoTablistContainer,
    ]
  );
}

function triggerStoreLocMarkerChangeEvent(aoStoreData) {
  $(document).trigger(
    storeLocMarkerChangeEventName,
    [
      aoStoreData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 *  when user reach any productlist while scrolling
 * @param {Array} aoData - Array of product on the productList
 */
function triggerScrollProductListEvent(aoData) {
  $(document).trigger(
    scrollToProductListEventName,
    [
      aoData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when one samples is clicked to add in the cart.
 * @param {Object} aoSamplesData       - Object of samples data.
 * @param {String} aoSamplesData.sku   - SKU for the product.
 * @param {String} aoSamplesData.title - Title for the product.
 */
function triggerSamplesAddedEvent(aoSamplesData) {
  $(document).trigger(
    samplesAddedEventName,
    [
      aoSamplesData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when one picture is clicked in the product carousel.
 * @param {Object} aoProductData       - Object of samples data.
 * @param {String} aoProductData.name - Name of the product.
 * @param {String} aoProductData.id   - ID for the product.
 * @param {String} aoProductData.imgId   - ID for the product image.
 */
function triggerProductPictureChangeEvent(aoProductData) {
  $(document).trigger(
    productPictureChangeEventName,
    [
      aoProductData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when arriving on Delivery or Payment checkout steps.
 * @param {Object} aoOption         - Object of option.
 * @param {String} aoOption.action  - event action.
 * @param {String} aoOption.step    - step number.
 * @param {String} aoOption.option  - option.
 */
function triggerCheckoutOptionEvent(aoOption) {
  $(document).trigger(
    checkoutOptionEventName,
    [
      aoOption,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when clicking on Check Stock in Store from the ProductPage.
 * @param {Object} aoProductData         - Object of option.
 * @param {String} aoProductData.name  - product name.
 * @param {String} aoProductData.id    - product id.
 */
function triggerCheckStockInStoreClickEvent(aoProductData) {
  $(document).trigger(
    checkStockInStoreClickEventName,
    [
      aoProductData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when Skincare Diagnostic
 * @param {Object} aoProductData         - Object.
 */
function triggerSkinDiagnosticCompletedEvent(asSkinDiagnosticData) {
  $(document).trigger(
    skinDiagnosticCompletedEventName,
    [
      asSkinDiagnosticData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * for each Skincare Diagnostic steps
 */
function triggerSkinCareDiagnosticPageviewEvent(asStepNumber) {
  $(document).trigger(
    skinCareDiagnosticPageviewEventName,
    [
      asStepNumber,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * for each Skincare Diagnostic steps
 */
function triggerBeautyProfileCompleteEvent(data) {
  $(document).trigger(
    beautyProfileCompletedEventName,
    [
      data,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when subscribing on Social Network in the Footer
 * @param {Object} aoSocialNetworkData  - Object.
 */
function triggerSocialFollowClickEvent(aoSocialNetworkData) {
  $(document).trigger(
    socialFollowEventName,
    [
      aoSocialNetworkData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * for each Skincare Diagnostic steps
 * @param {Object} promotionsTags         - module promotions tags data.
 */
function triggerPromotionViewEvent(promotionsTags) {
  $(document).trigger(
    promotionViewEventName,
    [
      promotionsTags
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when user clicks on a promotion in a module.
 * @param {Object} promotionTag         - module promotion tag data.
 */
function triggerPromotionClickedEvent(promotionTag) {
  $(document).trigger(
    promotionClickEventName,
    [
      promotionTag
    ]
  );
}

/**
 * Triggers the event that marks the moment
* when the user has clicked on the backInStockNotification btn and his email address is validated.
* @param {Object} aoProductData         - Object of option.
* @param {String} aoProductData.name  - product name.
* @param {String} aoProductData.id    - product id.
*/
function triggerBackInStockNotificationClickEvent(aoProductData) {
  $(document).trigger(
    backInStockNotificationEventName,
    [
      aoProductData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when the user has clicked on the read reviews link.
 * @param {Object} aoProductData         - Object of option.
 * @param {String} aoProductData.name  - product name.
 * @param {String} aoProductData.id    - product id.
 */
function triggerReadReviewsClickEvent(aoProductData) {
  $(document).trigger(
    readReviewsEventName,
    [
      aoProductData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when the user has clicked on the submit review button.
 * @param {Object} aoProductData         - Object of option.
 * @param {String} aoProductData.name  - product name.
 * @param {String} aoProductData.id    - product id.
 */
function triggerSubmitReviewEvent(aoProductData) {
  $(document).trigger(
    submitReviewEventName,
    [
      aoProductData,
    ]
  );
}


/**
 * Triggers the event that marks the moment
 * when one or more items have just been removed from the cart.
 * @param {Array}  aaProductsData         - Array of products data.
 * @param {String} aaProductsData[].sku   - SKU for the product.
 * @param {String} aaProductsData[].title - Title for the product.
 * @param {String} aaProductsData[].price - Price for the product.
 */
function triggerRemoveFromCartEvent(aaProductsData) {
  $(document).trigger(
    removeFromCartEventName,
    [
      aaProductsData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when Social Network Share CTA has been clicked.
 * @param {Array}  aaProductSocialData         - Array of products data.
 */
function triggerProductSocialViralityEvent(aoProductSocialData) {
  $(document).trigger(
    productSocialViralityEventName,
    [
      aoProductSocialData,
    ]
  );
}

/**
 * Triggers the event that marks the moment
 * when Express Delivery shipping method is selected.
 * @param {Array}  aaProductSocialData         - Array of products data.
 */
function triggerExpressDeliverySelectionEvent(aoShippingData) {
  $(document).trigger(
    expressDeliverySelectionEligibilityEventName,
    [
      aoShippingData,
    ]
  );
}

/**
 * Generic event handler.
 * @param {String}  asEventName      - The name of the event.
 * @param {Object}  aoThis           - The reference to the targetted DOM element.
 * @param {Array}   aaCallbackArgs   - Array of arguments for the event callback.
 * @param {Event}   aoEvent          - The event to handle.
 * (i.e. consider only its children).
 */
function genericEventHandler(asEventName, aoThis, aaCallbackArgs) {
  if (isEmpty(asEventName) || isEmpty(aaCallbackArgs) || !aaCallbackArgs.length) {
    return false;
  }

  const event = aaCallbackArgs[0];

  if (isEmpty(event)) {
    return false;
  }

  const target = event.currentTarget;
  const callbacksByTargets = eventCallbacks.get(asEventName);

  let callbacks = [];
  [...callbacksByTargets.entries()].forEach(([eventTarget, eventTargetCallbacks]) => {
    if ($(target).is($(eventTarget))) {
      callbacks = eventTargetCallbacks;

      return false; // break
    }

    return true; // continue
  });

  if (!isEmpty(callbacks)) {
    for (let i = 0; i < callbacks.length; i += 1) {
      callbacks[i].call(aoThis, ...aaCallbackArgs);
    }
  }

  return true;
}

/**
 * Sets an event handler.
 * @return {Boolean} Whether or not all went well.
 */
function setEventHandler(asEventName, aoCustomTarget = null) {
  const customTargets = eventNames.get(asEventName);
  const target = (aoCustomTarget != null) ? aoCustomTarget : document;
  const contextParams = customTargets.get(aoCustomTarget);

  let delegateEvent = false;

  if (!isEmpty(contextParams)) {
    if (!isEmpty(contextParams.delegateEvent)) {
      delegateEvent = contextParams.delegateEvent === true;
    }
  }

  // Get/Set the event handler
  let eventHandler = eventHandlers.get(asEventName);
  if (!eventHandler) {
    eventHandler = function oneEventHandler(...args) {
      return genericEventHandler(
        asEventName,
        this,
        args
      );
    };

    // Save reference to the event handler
    eventHandlers.set(asEventName, eventHandler);
  }

  // Attach the handler to the event
  if (!delegateEvent) {
    $(target).on(asEventName, eventHandler);
  } else {
    $(document).on(asEventName, target, eventHandler);
  }

  return true;
}

/**
 * Registers an event.
 * @param {String}        asEventName       - The name of the event.
 * @param {Object|String} [aoCustomTarget]  - The target of the event.
 * @param {Boolean}       [abDelegateEvent] - Indicator for whether or not to delegate the event.
 * (i.e. consider only its children).
 */
function registerEvent(asEventName, aoCustomTarget = null, abDelegateEvent) {
  if (isEmpty(asEventName)) {
    return;
  }

  // Save the event name
  if (!eventNames.has(asEventName)) {
    eventNames.set(asEventName, new Map());
  }

  // Save the custom target (if any)
  if (aoCustomTarget != null) {
    eventNames.get(asEventName).set(
      aoCustomTarget,
      {
        delegateEvent: abDelegateEvent || false,
      }
    );
  }

  // Set the handler for this event
  setEventHandler(asEventName, aoCustomTarget);
}

/**
 * Registers one or many callbacks for the given event(s).
 * @param  {Object|String} options.events:       The name(s) of the event(s) or an object with
 * event/handler pairs.
 * @param  {Function}      options.handler:      The callback for the event(s).
 * @param  {Object|String} options.target:       The target of the event(s).
 * @param  {Boolean}       options.delegate:     Indicator for whether or not to delegate
 * the event(s).
 * @return {Boolean} Whether or not all went well.
 */
function registerCallback({
  events = null,
  handler = null,
  target = null,
  delegate = false,
} = {}) {
  if (
    isEmpty(events)
    || ($.isPlainObject(events) && $.isEmptyObject(events))
    || (!$.isPlainObject(events) && (typeof events !== 'string'))
    || isEmpty(target)
  ) {
    return false;
  }

  const mapEventHandlers = new Map();

  if (typeof events === 'string') {
    if (isEmpty(handler) || (typeof handler !== 'function')) {
      return false;
    }

    // Get events and handlers from string

    const givenEvents = events.split(' ');

    givenEvents.forEach((eventName) => {
      mapEventHandlers.set(eventName, handler);
    });
  } else if ($.isPlainObject(events)) {
    // Get events and handlers from object

    Object.entries(events).forEach(([eventName, eventHandler]) => {
      mapEventHandlers.set(eventName, eventHandler);
    });
  }

  if (!mapEventHandlers.size) {
    return false;
  }

  mapEventHandlers.forEach((eventHandler, eventName) => {
    if (!eventCallbacks.has(eventName)) {
      eventCallbacks.set(eventName, new Map());
    }

    if (!eventCallbacks.get(eventName).has(target)) {
      eventCallbacks.get(eventName).set(target, []);
    }

    // Register the callback
    eventCallbacks.get(eventName).get(target).push(eventHandler);

    // Register the event
    registerEvent(eventName, target, delegate === true);
  });

  return true;
}

// Named exports - Constants
export {
  headerReadyEventName,
  siteReadyEventName,
  dataLayerReadyEventName,
  openPopinEventName,
  closePopinEventName,
  cartUpdateEventName,
  cartItemAddedEventName,
  cartItemRemovedEventName,
  cartItemQtyReachLimitEventName,
  cartItemQtyBelowLimitEventName,
  wishlistItemAddedEventName,
  wishlistItemRemovedEventName,
  productThumbnailClickedEventName,
  algoliaProductThumbnailClickedEventName,
  productListShowMoreEventName,
  algoliaProductListShownEventName,
  productListSortByEventName,
  algoliaProductListSortByEventName,
  productListFilterByEventName,
  algoliaProductListFilterByEventName,
  tablistTabChangeEventName,
  storeLocMarkerChangeEventName,
  samplesAddedEventName,
  productPictureChangeEventName,
  checkoutOptionEventName,
  checkStockInStoreClickEventName,
  scrollToProductListEventName,
  skinDiagnosticCompletedEventName,
  skinCareDiagnosticPageviewEventName,
  beautyProfileCompletedEventName,
  promotionViewEventName,
  promotionClickEventName,
  socialFollowEventName,
  backInStockNotificationEventName,
  readReviewsEventName,
  submitReviewEventName,
  removeFromCartEventName,
  productSocialViralityEventName,
  expressDeliverySelectionEligibilityEventName,
  expressDeliverySelectionIneligibilityEventName
};

// Named exports - Properties
export {
  eventNames,
  eventHandlers,
  eventCallbacks,
};

// Named exports - Functions
export {
  registerCallback,
  triggerCartUpdateEvent,
  triggerCartItemAddedEvent,
  triggerCartItemRemovedEvent,
  triggerWishlistItemAddedEvent,
  triggerWishlistItemRemovedEvent,
  triggerProductThumbnailClickedEvent,
  triggerAlgoliaProductThumbnailClickedEvent,
  triggerProductListShowMoreEvent,
  triggerAlgoliaProductListShownEvent,
  triggerProductListSortByEvent,
  triggerAlgoliaProductListSortByEvent,
  triggerProductListFilterByEvent,
  triggerAlgoliaProductListFilterByEvent,
  triggerTablistTabChangeEvent,
  triggerStoreLocMarkerChangeEvent,
  triggerSamplesAddedEvent,
  triggerProductPictureChangeEvent,
  triggerCheckoutOptionEvent,
  triggerCheckStockInStoreClickEvent,
  triggerScrollProductListEvent,
  triggerSkinDiagnosticCompletedEvent,
  triggerSkinCareDiagnosticPageviewEvent,
  triggerBeautyProfileCompleteEvent,
  triggerPromotionViewEvent,
  triggerPromotionClickedEvent,
  triggerSocialFollowClickEvent,
  triggerBackInStockNotificationClickEvent,
  triggerReadReviewsClickEvent,
  triggerSubmitReviewEvent,
  triggerRemoveFromCartEvent,
  triggerProductSocialViralityEvent,
  triggerExpressDeliverySelectionEvent
};



// WEBPACK FOOTER //
// ./js/common/Events.js